// components/RadarChrt.js
import React from "react";
import { Modal, Button } from "react-bootstrap";
import { PolarArea } from "react-chartjs-2";
import {
  Chart as ChartJS,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

// Register the necessary components for Chart.js
ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);

// Mapping kategori → skor
const SCORE_MAP = {
  "LAYAK": 100,
  "MENUJU LAYAK": 75,
  "AGAK LAYAK": 50,
  "KURANG LAYAK": 25,
  "TIDAK LAYAK": 0,
};

const PolarAreaChrt = ({ show, onHide, assessment, rumah }) => {

  if (!assessment) return null;

  const data = {
    labels: [
      "Fondasi",
      "Sloof",
      "Kolom",
      "Balok",
      "Rangka Atap",
      "Lantai",
      "Dinding",
      "Jendela",
      "Ventilasi",
    ],
    datasets: [
      {
        label: "Skor Kondisi",
        data: [
          SCORE_MAP[assessment.foundation] || 0,
          SCORE_MAP[assessment.sloof_condition] || 0,
          SCORE_MAP[assessment.column_condition] || 0,
          SCORE_MAP[assessment.beam_condition] || 0,
          SCORE_MAP[assessment.roof_frame_condition] || 0,
          SCORE_MAP[assessment.floor_condition] || 0,
          SCORE_MAP[assessment.wall_condition] || 0,
          SCORE_MAP[assessment.window] || 0,
          SCORE_MAP[assessment.ventilation] || 0,
        ],
        backgroundColor: [
          "rgba(250, 170, 190, 0.6)",
          "rgba(210, 230, 150, 0.6)",
          "rgba(170, 190, 210, 0.6)",
          "rgba(230, 150, 170, 0.6)",
          "rgba(190, 210, 130, 0.6)",
          "rgba(150, 170, 250, 0.6)",
          "rgba(210, 130, 210, 0.6)",
          "rgba(170, 250, 170, 0.6)",
          "rgba(130, 210, 230, 0.6)",
        ],
        borderWidth: 1,
      },
    ],
  };

  // Format data ke bentuk { subject, value }

  const options = {
    responsive: true,
    scales: {
      r: {
        angleLines: {
          display: false,
        },
        suggestedMin: 0,
        suggestedMax: 10,
      },
    },
  };

  return (
    <Modal show={show} onHide={onHide} size="sd" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Polar Area Chart - {rumah?.household_head_name || "Rumah"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex justify-content-center flex-column align-items-center gap-2">
        <PolarArea data={data} options={options} />
        <div className=""> TOTAL SCORE </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Tutup
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PolarAreaChrt;
